import { getUserHomePath } from '../../shared/config/env';
import { useMetaTags } from '../../shared/hooks/useMetaTags';
import './ServerError.css';

/**
 * 500 Server Errorページコンポーネント
 * ErrorBoundary で表示されるため Router の外でレンダーされることがあるため、
 * ホームへのリンクは <a href> を使用する（Link は Router 必須のため使用しない）
 */
function ServerError() {
  const homePath = getUserHomePath();

  // メタタグを設定
  useMetaTags({
    title: '500 - サーバーエラー | ブログ',
    description: 'サーバーでエラーが発生しました。',
  });

  return (
    <div className="server-error">
      <div className="server-error__container">
        <div className="server-error__animation">
          <div className="server-error__number">5</div>
          <div className="server-error__cat">
            <div className="server-error__cat-body">
              <div className="server-error__cat-ear server-error__cat-ear--left"></div>
              <div className="server-error__cat-ear server-error__cat-ear--right"></div>
              <div className="server-error__cat-face">
                <div className="server-error__cat-eye server-error__cat-eye--left"></div>
                <div className="server-error__cat-eye server-error__cat-eye--right"></div>
                <div className="server-error__cat-nose"></div>
                <div className="server-error__cat-mouth"></div>
              </div>
            </div>
            <div className="server-error__cat-tail"></div>
          </div>
          <div className="server-error__number">0</div>
          <div className="server-error__number">0</div>
        </div>
        <h1 className="server-error__title">サーバーエラーが発生しました</h1>
        <p className="server-error__message">
          申し訳ございません。サーバーでエラーが発生しました。
          <br />
          しばらく時間をおいてから再度お試しください。
        </p>
        <div className="server-error__actions">
          <a href={homePath} className="server-error__button server-error__button--primary">
            ホームに戻る
          </a>
          <button
            onClick={() => window.location.reload()}
            className="server-error__button server-error__button--secondary"
          >
            ページを再読み込み
          </button>
        </div>
      </div>
    </div>
  );
}

export default ServerError;

